export default "__VITE_ASSET__mbUJWgq4__"